import React from 'react';
import { connect } from 'react-redux';
import {
  fetchPersonalAlert,
  removePersonalAlert,
  REDUCER_NAME as ALERT_REDUCER_NAME,
  changeActivePersonalAlert,
  ACTIVATE,
  INACTIVATE,
} from '../../../main-layout/header/right/alerts/reducer';
import Const from './Const';
import { REDUCER_NAME } from '../reducer';
import STTable from './../../../common/mixTable/STTable';

class AlertSystemTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isHover: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { i18n, fetchPersonalAlert } = this.props;
    if (prevProps.i18n.locale !== i18n.locale) {
      fetchPersonalAlert();
    }
  }

  getDataFromRedux = state => state[ALERT_REDUCER_NAME].personalAlertById;

  handleDelete = (e, id) => {
    const { removePersonalAlert } = this.props;
    removePersonalAlert(id);
  };

  handleToggleActive = (prevActive, item) => {
    const { changeActivePersonalAlert } = this.props;
    const statusMap = {
      [true]: ACTIVATE,
      [false]: INACTIVATE,
    };
    const params = {
      personalAlertId: item.personalAlertId,
      status: statusMap[!prevActive],
    };
    changeActivePersonalAlert(params);
  };

  render() {
    const { isLoading, ids, handleModify, parentRef } = this.props;
    const objectConfirmDel = {
      title: 'alertPersonal.confirmDel.title',
      textContent: 'alertPersonal.confirmDel.content',
      parentRef: parentRef ? parentRef.current : null,
      onOverlayClicked: true,
      handleClickDelete: this.handleDelete,
    };

    return (
      <STTable
        ids={ids}
        handleToggle={this.handleToggleActive}
        isLoading={isLoading}
        getDataFromRedux={this.getDataFromRedux}
        handleModify={handleModify}
        schemaKey={'alertPersonal.alertPersonalHeader'}
        listColumn={Const.listColumn}
        objectConfirmDel={objectConfirmDel}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    ids: state[ALERT_REDUCER_NAME].personalAlertIds,
    isShowPopupSetting: state[REDUCER_NAME].isShowPopupSetting,
    featureType: state[REDUCER_NAME].featureType,
    isLoading: state[ALERT_REDUCER_NAME].isPersonalAlertLoading,
    i18n: state.i18n,
  };
};

const mapDispatchToProps = {
  removePersonalAlert,
  fetchPersonalAlert,
  changeActivePersonalAlert,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlertSystemTable);
